export type Action = 'delete' | 'leave' | 'reject_connection' | 'reject_group' | 'delete_connection' |
'delete_group' | 'stop_protocol' | 'change_end_date' | 'skip_optional_consent' | 'reject_transfer_request' | 'create_transfer_request'

export enum ActionType {'action_before', 'action_after'}
